<template>
  <div class="recordDownload">
    <setting-header />
    <v-spacer class="recordDownload_gap-header" />
    <div
      v-for="(item, i) in items"
      :key="i"
      v-ripple
      class="recordDownload_select"
      @click="select(i)"
    >
      <div
        class="recordDownload_select-icon"
        :class="{ ['recordDownload_select-checked']: selectedItems[i] }"
      >
        <span class="icon icon-check" />
      </div>
      <span class="recordDownload_select-text">{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
import SettingHeader from './SettingHeader.vue';

export default {
  name: 'RecordDownload',
  components: {
    SettingHeader,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    selectedItems: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    select(i) {
      this.$emit('onSelect', i);
    },
  },
};
</script>

<style lang="scss">
.recordDownload {
  &_gap-header {
    height: 15px;
  }
  &_select {
    display: flex;
    align-items: center;
    padding: 10px;
    border-top: 1px solid #eeeeee;
    cursor: pointer;
    &:last-child {
      border-bottom: 1px solid #eeeeee;
    }
    &:hover {
      background-color: #f3f3f3;
    }
    &-icon {
      width: 24px;
      height: 24px;
      padding: 2px 5px 5px 2px;
      border-radius: 50%;
      border: 1px solid #989898;
      .icon-check {
        color: #fff;
        font-size: 18px;
        font-weight: 900;
        display: none;
      }
    }
    &-checked {
      background-color: #0075c2;
      border-color: transparent;
      .icon-check {
        display: block;
      }
    }
    &-text {
      margin-left: 5px;
      font-size: 14px;
      line-height: 1.14;
      text-align: left;
      color: #4b4b4b;
    }
  }
}
</style>
